/**
 * format.js — Currency and percentage display helpers.
 */
export const F = (n) => {
  if (n == null || isNaN(n)) return "$0";
  if (Math.abs(n) >= 999500) return "$" + (n / 1e6).toFixed(2) + "M";
  if (Math.abs(n) >= 1e3) return "$" + (n / 1e3).toFixed(0) + "k";
  return "$" + Math.round(n).toLocaleString();
};
export const FF = (n) => "$" + Math.round(n || 0).toLocaleString();
export const P = (n) => (n * 100).toFixed(1) + "%";
